"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    lookupList: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    type: {
      type: String,
      default: ''
    },
    isBailianFlag: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  }
};